import { Navigate, useLocation } from "react-router-dom";

const OrderRoute = ({ children }) => {
  const location = useLocation();
  const authData = localStorage.getItem("auth");
  const parsedAuth = authData ? JSON.parse(authData) : {};
  const token = parsedAuth?.token;

  const orderPlaced = localStorage.getItem("orderPlaced");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!orderPlaced) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default OrderRoute;
